import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ListPostbacks from './ListPostbacks.js';
import { actions } from './ListPostbacks.actions';
import {
    getHeaderNames,
    getListPostbacks
} from './ListPostbacks.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    list: getListPostbacks
});

const ListPostbacksComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            goalActions: state.goalActions.list,
            page: state.postbacks.list.page,
            total: state.postbacks.list.total,
            loading: state.postbacks.list.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getListPostbacks: actions.getListPostbacks.bind(actions),
            getListGoalActionsByIds: actions.getListGoalActionsByIds,
            onDeletePostback: actions.onDeletePostback.bind(actions)
        };
    }
)(ListPostbacks);

export default ListPostbacksComponent;
